import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RvServerResponseItemsDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'kt-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {
  item: RvServerResponseItemsDto;

  constructor(
    private dialogRef: MatDialogRef<PopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RvServerResponseItemsDto
  ) {
    this.item = data;
   }

  ngOnInit() {
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
